import * as React from "react";
import { Link } from "react-router-dom";
import { ListView, Page, PageHero, Spinner } from "src/components/common";
import { Button } from "src/components/buttons";
import DatasetAuthorizationWrapper from "src/common/DatasetAuthorizationWrapper";

import { DatePicker, Tooltip } from "antd";
import moment, { Moment } from "moment";

import ClientAPI from "./ClientAPI";
import PickListContext from "src/context/pickListContext";
import CustomFieldAPI from "src/admin/Organization/CustomFields/CustomFieldAPI";
import { CustomFields } from "src/common/CustomFields";
import {
	setStatusCellValue,
	filterByStatus,
	StatusFilterMethod,
} from "src/components/forms/StatusFilter";
import {
	filterByLinked,
	LinkedFilterMethod,
	setLinkedCellValue,
} from "src/components/forms/LinkedFilter";
import ClientDatasetAPI from "../clientsiteresults/ClientDatasetAPI";
import { rowDateSortFunction } from "src/common/utils";
import { AdminPermissions } from "src/common/Permissions";
import { filter } from "lodash";

interface IProps {
	history?: any;
	location?: any;
	match?: any;
	customFields: CustomFieldDTO[];
	currentUser?: any;
}

interface IState {
	filtered: any[];
	clients: ClientDTO[];
	isLoading: boolean;
	customFields: CustomFieldDTO[];
	createdDateValue: Moment | undefined;
	dataset: DatasetDTO;
}

class ClientsListView extends React.Component<IProps, IState> {
	public static contextType = PickListContext;
	constructor(props: IProps) {
		super(props);
		this.state = {
			filtered: [],
			clients: [],
			customFields: [],
			isLoading: false,
			createdDateValue: undefined,
			dataset: {},
		};
	}

	public componentDidMount() {
		const { organizationId, datasetId } = this.props.match.params;
		this.setState({ isLoading: true });
		ClientAPI.getClientSiteClients(Number(datasetId)).then((response) =>
			this.setState({ clients: response, isLoading: false })
		);

		ClientDatasetAPI.getDatset({
			organizationId,
			datasetId,
		}).then((d) => {
			this.setState({ dataset: d });
		});

		CustomFieldAPI.getOrganizationCustomFields(+organizationId, datasetId).then(
			(customFields) => {
				const returnedCustomFields = this.returnClientCustomFields(
					customFields,
					datasetId
				);
				this.setState({ customFields: returnedCustomFields });
			}
		);
		this.setState({ filtered: [{ id: "isActive", value: "Active" }] });
	}

	public getActionLink = (rowId: any): string => {
		return `./clients/${rowId}/results`;
	};

	public onRowClick = (row: any) => {
		this.props.history.push(this.getActionLink(row.original.id));
	};

	public render() {
		const { organizationId } = this.props.match.params;
		const linkTo = this.props.currentUser.permissions!.includes(
			AdminPermissions.GlobalAdmin
		)
			? `/organizations/${organizationId}/datasets/admin`
			: `/organizations/${organizationId}/datasets`;

		const columns = this.getColumns(this.state.customFields); // this.props.history.location.state.CustomFields
		return this.state.isLoading !== false ? (
			<Spinner size="full-page" />
		) : (
			<Page title="Participants">
				<PageHero>
					<Link to={linkTo}>&lt; DATASETS</Link>
					<div className="d-flex align-items-start">
						<h1>Participants</h1>
						<DatasetAuthorizationWrapper
							type="hide"
							permissions={["EditClient"]}
						>
							<Button
								to={`/organizations/${this.props.match.params.organizationId}/datasets/${this.props.match.params.datasetId}/clients/-1/details`}
								className="ml-auto btn-primary"
							>
								New Participant
							</Button>
						</DatasetAuthorizationWrapper>
					</div>
				</PageHero>
				<div className="container-fluid">
					<ListView<ClientDTO>
						filtered={this.state.filtered}
						collectionName={`datasets/${this.props.match.params.datasetId}/clients`}
						data={this.state.clients}
						columnDefinitions={columns}
						onRowClick={this.onRowClick}
						onItemNavigate={this.onItemNavigate}
						storageKey={"ClientListGrid"}
					/>
				</div>
			</Page>
		);
	}

	private onItemNavigate = (item: ClientDTO) => {
		this.props.history.push(
			`/organizations/${this.props.match.params.organizationId}/datasets/${this.props.match.params.datasetId}/clients/${item.id}/results`
		);
	};

	private returnClientCustomFields = (
		customFields: CustomFieldDTO[],
		datasetId: number
	) => {
		const fieldType: PickListItemResponseDTO = this.context.pickListItems.find(
			(p: PickListItemResponseDTO) => p.code === "ClientType"
		);
		const returnedCustomFields = customFields.filter(
			(cf) =>
				cf.showInListView === true &&
				cf.customFieldType === fieldType.id &&
				cf.datasetIds!.includes(+datasetId)
		);
		return returnedCustomFields;
	};

	private getColumns = (fields: CustomFieldDTO[]) => {
		const columns = [
			{
				Header: <Tooltip title="Participant Code">Participant Code</Tooltip>,
				accessor: "clientCode",
				filterable: true,
			},
			{
				Header: (
					<Tooltip title="Employee Id">
						{this.state.dataset.productId === "ExceleRATEV2"
							? "Employee Id"
							: "Id"}
					</Tooltip>
				),
				show: this.state.dataset.showClientParticipantId,
				accessor: "employeeId",
				filterable: true,
			},
			{
				Header: <Tooltip title="First Name">First Name</Tooltip>,
				show: this.state.dataset.showClientFirstName,
				accessor: "firstName",
			},
			{
				Header: <Tooltip title="Last Name">Last Name</Tooltip>,
				show: this.state.dataset.showClientLastName,
				accessor: "lastName",
			},
			{
				Header: <Tooltip title="Created Date">Created Date</Tooltip>,
				id: "createdDate",
				filterable: true,
				accessor: (d: any) => {
					return moment.utc(d.createdDate).local().format("MMM DD, YYYY");
				},
				sortMethod: rowDateSortFunction,
				filterMethod: (filter: any, rowData: any) =>
					filter.value !== null
						? rowData.createdDate === filter.value.format("MMM DD, YYYY")
						: rowData.createdDate,
				Filter: ({ filter, onChange }: { filter: any; onChange: any }) => (
					<DatePicker
						onChange={onChange}
						allowClear={true}
						style={{ width: "100%" }}
						format="MMM DD, YYYY"
						value={filter ? filter.value : undefined}
					/>
				),
			},
			{
				Header: <Tooltip title="Last Test Date">Last Test Date</Tooltip>,
				id: "lastTestDate",
				filterable: true,
				accessor: (d: any) => {
					return d.lastTestDate
						? moment.utc(d.lastTestDate).local().format("MMM DD, YYYY")
						: "";
				},
				sortMethod: rowDateSortFunction,
				filterMethod: (filter: any, rowData: any) =>
					filter.value !== null
						? rowData.lastTestDate === filter.value.format("MMM DD, YYYY")
						: rowData.lastTestDate,
				Filter: ({ filter, onChange }: { filter: any; onChange: any }) => (
					<DatePicker
						onChange={onChange}
						allowClear={true}
						style={{ width: "100%" }}
						format="MMM DD, YYYY"
						value={filter ? filter.value : undefined}
					/>
				),
			},
			{
				Header: <Tooltip title="Status">Status</Tooltip>,
				accessor: "isActive",
				Cell: setStatusCellValue,
				filterMethod: filterByStatus("isActive"),
				Filter: StatusFilterMethod,
			},
			{
				Header: <Tooltip title="Neurapulse">Neurapulse</Tooltip>,
				accessor: "neurapulseLinked",
				show: this.state.dataset.neurapulseProjectId !== undefined,
				Cell: setLinkedCellValue,
				filterMethod: filterByLinked("neurapulseLinked"),
				Filter: LinkedFilterMethod,
			},
		];

		let customColumns: any = [];
		if (fields.length > 0) {
			customColumns = CustomFields.renderCustomFieldColumn(
				fields,
				CustomFields.changeCustomFieldLabelValue
			);
		}

		const newColumns = [...columns, ...customColumns];
		return newColumns;
	};
}

export default ClientsListView;
